import { useLayoutEffect, useMemo, useState } from "react";
import {
  emptyFilters,
  cycleFilterValue,
  itemMatchesFilters,
  matchesSearch,
  clearInvalidFilters,
} from "../utils/initiativeFilters";

export const useInitiativeFiltering = (initiatives) => {
  const [filters, setFilters] = useState(emptyFilters);
  const [searchQuery, setSearchQuery] = useState("");

  useLayoutEffect(() => {
    setFilters((prev) => clearInvalidFilters(prev, initiatives));
  }, [initiatives]);

  const visibleInitiatives = useMemo(
    () =>
      initiatives.filter(
        (item) =>
          itemMatchesFilters(item, filters) && matchesSearch(item, searchQuery),
      ),
    [initiatives, filters, searchQuery],
  );

  const dashboardInitiatives = useMemo(
    () => initiatives.filter((item) => itemMatchesFilters(item, filters)),
    [initiatives, filters],
  );

  const handleMetricClick = (key, value) =>
    setFilters((prev) => ({ ...prev, [key]: { [value]: "include" } }));

  const handleToggleFilter = (key, value) =>
    setFilters((prev) => cycleFilterValue(prev, key, value));

  const handleClearFilters = () => setFilters(emptyFilters());

  return {
    filters,
    searchQuery,
    setSearchQuery,
    visibleInitiatives,
    dashboardInitiatives,
    handleToggleFilter,
    handleClearFilters,
    handleMetricClick,
  };
};
